module.exports = __webpack_public_path__ + "static/media/geneticka_analyza.bb787fd3.md";